import { render } from "./ComposeMessage.vue?vue&type=template&id=74f699d2"
import script from "./ComposeMessage.vue?vue&type=script&lang=js"
export * from "./ComposeMessage.vue?vue&type=script&lang=js"

import "./ComposeMessage.vue?vue&type=style&index=0&id=74f699d2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__